let videoSourceInstance: HTMLCanvasElement
const getVideoSource = () => {
  if (!videoSourceInstance) {
    videoSourceInstance = document.createElement('canvas')
  }
  return videoSourceInstance
}
let audioContextInstance: AudioContext
const getAudioSource = () => {
  if (!audioContextInstance) {
    audioContextInstance = new AudioContext()
  }
  return audioContextInstance
}

export const useEmptyMediaStream = () => {

  const getEmptyAudioTrack = (): MediaStreamTrack => {
    const [track] = getAudioSource().createMediaStreamDestination().stream.getAudioTracks()
    return track!
  }

  const getEmptyVideoTrack = (): MediaStreamTrack => {
    const [track] = getVideoSource().captureStream().getVideoTracks()
    return track!
  }

  const getEmptyMediaStream = (): MediaStream => {
    const mediaStream = new MediaStream()
    mediaStream.addTrack(getEmptyAudioTrack())
    mediaStream.addTrack(getEmptyVideoTrack())
    return mediaStream
  }

  return {
    getEmptyAudioTrack,
    getEmptyVideoTrack,
    getEmptyMediaStream,
  }
}
